<template>
    <div id="content" class="load_transition" :class="submitting ? 'load_block' : ''">

        <div class="alert alert-danger alert-dismissible" role="alert" v-if="success === false">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            The given data was invalid.
        </div>

        <div class="alert alert-success alert-dismissible" role="alert" v-if="success === true">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            Success
        </div>

        <div class="form-group row align-items-center">
            <label class="col-form-label text-md-right col-md-2">Група</label>
            <div class="col-md-9">
                <multiselect
                    v-model="selected.group"
                    label="name"
                    track-by="id"
                    :options="groups"
                    :multiple="false"
                    open-direction="bottom"
                    @input="getStudents()">
                </multiselect>
            </div>
        </div>

        <div class="form-group row align-items-center" v-if="students.length">
            <label class="col-form-label text-md-right col-md-2">Студент</label>
            <div class="col-md-9">
                <multiselect
                    v-model="selected.student"
                    label="full_name"
                    track-by="id"
                    :options="students"
                    :multiple="false"
                    open-direction="bottom"
                    @input="getPrograms()">
                </multiselect>
            </div>
        </div>

        <div class="form-group row align-items-center" v-if="programs.length">
            <label class="col-form-label text-md-right col-md-2">Програма</label>
            <div class="col-md-9">
                <multiselect
                    v-model="selected.program"
                    label="name"
                    track-by="id"
                    :options="programs"
                    :multiple="false"
                    open-direction="bottom"
                    @input="getQuestions()">
                </multiselect>
            </div>
        </div>

        <div class="questions" v-for="section in form.sections" v-if="selected.student && selected.group">
            <hr>
            <div class="section col-sm-12">
                <p><b>Розділ: </b>{{ section.title }}</p>
            </div>
            <div class="question_block" v-for="question in section.questions">
                <div class="question col-sm-12">
                    <div class="question-item">
                        <p><b>Питання:</b><span data-toggle="tooltip" :title="question.hint"><i class="fa fa-fw fa-info-circle"></i></span>{{ question.question }}</p>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-12">
                        <label class="col-form-label text-md-left font-weight-normal">Відповідь:</label>
                        <div>
                            <textarea rows="5" v-if="question.student_answer" v-model="question.student_answer.answer" name="answer" placeholder="Відповідь" class="form-control form-control-success" aria-required="true" aria-invalid="false"></textarea>
                            <textarea rows="5" v-else v-model="question.answer" name="answer" placeholder="Відповідь" class="form-control form-control-success" aria-required="true" aria-invalid="false"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group" v-if="form.sections.length && selected.student && selected.group">
            <div>
                <button class="btn btn-primary btn-sm m-b-0" @click="saveAnswers()"><i class="fa fa-save"></i> Save </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: ['groups'],
    name: "StartupitReportComponent",
    data() {
        return{
            type: 'startupit',
            form: {
                sections: {},
                student: {},
                program: {},
            },
            selected: {
                group: false,
                program: false,
                student: false,
            },
            programs: [],
            students: [],
            submitting: false,
            success: null,
            showPrograms: true
        }
    },
    methods: {
        async getPrograms() {
            this.submitting = true;
            try {
                const { data : { programs }} = await axios.get('/teacher/dashboard/questionnaire/getProgramsByGroup/' + this.selected.group.id);
                this.programs = programs;
                this.form.sections = []
                this.selected.program = false
                this.submitting = false
            } catch (err) {
                this.selected.program = false
                this.submitting = false
            }
        },
        async getStudents() {
            this.submitting = true;
            try {
                const response = await axios.get('/teacher/dashboard/questionnaire/getStudentsByGroup/' + this.selected.group.id);
                this.students = response.data;
                this.selected.student = false
                this.selected.program = false
                this.form.sections = []
                this.submitting = false
            } catch (err) {
                this.selected.student = false
                this.submitting = false
            }
        },
        async getQuestions() {
            this.submitting = true;
            try {
                this.form.program = this.selected.program;
                this.form.student = this.selected.student;
                this.form.sections = []

                if (this.selected.program) {
                    const response = await axios.get('/teacher/dashboard/questionnaire/getQuestions/' + this.selected.student.id + '?program_id=' + this.selected.program.id + '&type=' + this.type);
                    this.form.sections = [ ...this.form.sections, ...response.data];
                }

                // this.form.selected = this.selected;
                this.submitting = false
            } catch (err) {
                this.submitting = false
            }
        },
        async saveAnswers() {
            this.submitting = true;
            try {
                await axios.post('/teacher/dashboard/questionnaire/saveAnswers', this.form );
                await this.getQuestions();
                this.success = true;
                this.submitting = false;
                setTimeout(() => {
                    this.success = null
                }, 6000);
            } catch (err) {
                this.submitting = false
            }
        }
    },
}
</script>
<style scoped>
    .load_block {
        opacity: 0.3;
        pointer-events: none;
    }
    .load_transition {
        transition: 0.2s;
    }
    .form-group{
        margin-bottom: 15px;
    }
</style>
